import React from 'react';
import propTypes from 'prop-types';
import { useConfig } from '../../config/ContentComponentLibraryProvider';
import { warn } from '../../utils/error-logging';
import { ALL_IMAGE_WIDTH_SIZES, LG_IMAGE_WIDTH_SIZES, MD_IMAGE_WIDTH_SIZES, SM_IMAGE_WIDTH_SIZES, } from './constants';
const getMedia = breakpoint => {
    if (breakpoint === 'mobile')
        return '(max-width: 544px)';
    if (breakpoint === 'tablet')
        return '(max-width: 991px) and (min-width: 544px)';
    if (breakpoint === 'desktop-and-tablet')
        return '(min-width: 544px)';
    return undefined;
};
const fit = 'fit=constrain%2C0';
const breakpointImageWidthSizes = {
    mobile: [...SM_IMAGE_WIDTH_SIZES, ...MD_IMAGE_WIDTH_SIZES],
    tablet: [...MD_IMAGE_WIDTH_SIZES, ...LG_IMAGE_WIDTH_SIZES],
};
export const buildSrcSet = (scene7Url, breakpoint) => {
    const imageWidthSizes = breakpointImageWidthSizes[breakpoint] || ALL_IMAGE_WIDTH_SIZES;
    return imageWidthSizes.map(width => `${scene7Url}&wid=${width}&${fit} ${width}w`).join(',');
};
function Sources({ scene7Url, breakpoint, sizes, media, height, width, preload }) {
    var _a;
    const config = useConfig();
    if (!scene7Url)
        return null;
    const srcSet = buildSrcSet(scene7Url, breakpoint);
    if (preload && !config.headFunction) {
        warn('Component Library: preloadImages is set to true but no headFunction has been supplied to the config.');
    }
    return (React.createElement(React.Fragment, null,
        preload &&
            ((_a = config.headFunction) === null || _a === void 0 ? void 0 : _a.call(config, React.createElement("link", { rel: "preload", as: "image", href: scene7Url, imagesrcset: srcSet, imagesizes: sizes, "data-testid": "image-preload-link", fetchpriority: "high" }))),
        React.createElement("source", { "data-testid": "source", srcSet: buildSrcSet(scene7Url, breakpoint), media: media || getMedia(breakpoint), sizes: sizes, height: height, width: width })));
}
Sources.defaultProps = {
    scene7Url: undefined,
    breakpoint: undefined,
    sizes: undefined,
    media: undefined,
    height: undefined,
    width: undefined,
    preload: false,
};
Sources.propTypes = {
    scene7Url: propTypes.string,
    breakpoint: propTypes.string,
    sizes: propTypes.string,
    media: propTypes.string,
    height: propTypes.string,
    width: propTypes.string,
    preload: propTypes.bool,
};
export default Sources;
//# sourceMappingURL=Sources.js.map